import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusStyles = (status) => {
    switch (status) {
      case 'not_started':
        return 'bg-gray-100 text-gray-600';
      case 'in_progress':
        return 'bg-blue-100 text-blue-600';
      case 'submitted':
        return 'bg-yellow-100 text-yellow-600';
      case 'under_review':
        return 'bg-purple-100 text-purple-600';
      case 'approved':
        return 'bg-green-100 text-green-600';
      case 'rejected':
        return 'bg-red-100 text-red-600';
      case 'requires_resubmission':
        return 'bg-orange-100 text-orange-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };

  const formatStatus = (status) => {
    return status?.replace(/_/g, ' ')?.replace(/\b\w/g, l => l.toUpperCase()) || status;
  };

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusStyles(status)}`}>
      {formatStatus(status)}
    </span>
  );
};

export default StatusBadge;
